export default function BusinessUsageIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_11695_33346'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_11695_33346)'>
        <path
          d='M3.25 20.7536V19.1094L4.75 17.6094V20.7536H3.25ZM7.25 20.7536V15.1094L8.75 13.6094V20.7536H7.25ZM11.25 20.7536V13.6094L12.75 15.1344V20.7536H11.25ZM15.25 20.7536V15.1344L16.75 13.6344V20.7536H15.25ZM19.25 20.7536V11.1094L20.75 9.60938V20.7536H19.25ZM3.25 15.2229V13.1094L10 6.35938L14 10.3594L20.75 3.60938V5.72288L14 12.4729L10 8.47288L3.25 15.2229Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
